import { render, staticRenderFns } from "./ContractSummaryTab.vue?vue&type=template&id=5715aedb&scoped=true"
import script from "./ContractSummaryTab.vue?vue&type=script&lang=js"
export * from "./ContractSummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715aedb",
  null
  
)

export default component.exports